import { render, staticRenderFns } from "./EventFinishPage.vue?vue&type=template&id=aab91534"
import script from "./EventFinishPage.vue?vue&type=script&lang=js"
export * from "./EventFinishPage.vue?vue&type=script&lang=js"
import style0 from "./EventFinishPage.vue?vue&type=style&index=0&id=aab91534&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports